(function(){
    "use strict";

    angular
        .module('pwc.controllers')
        .controller('WineActionPanelController', WineActionPanelController);

    WineActionPanelController.$inject = ['$mdDialog', 'mdPanelRef', 'wine', 'lodash', '$log', 'Utils', 'DialogService', 'userPouch', 'MessageService'];

    function WineActionPanelController($mdDialog, mdPanelRef, wine, lodash, $log, Utils, DialogService, userPouch, MessageService){

        /* jshint validthis: true */
        var self = this;

        self.wine = wine;

        self.edit = edit;
        self.copy = copy;
        self.purchase = purchase;
        self.subtract = subtract;
        self.confirmDelete = confirmDelete;
        self.close = close;

        /** begin methods */

        function edit(){

            close().then(function(){
                Utils.go('wines/edit', {id: wine['_id']});
            });
        }

        function copy(){

            close().then(function(){
                Utils.go('wines/copy', {id: wine['_id']});
            });
        }

        function purchase(){

            close().then(function(){
                DialogService.purchase(wine, null, null, true);
            });
        }

        function subtract(){

            close().then(function(){
                return DialogService.subtract(wine, true);
            });
        }

        function close(){
            return mdPanelRef.close();
        }

        function confirmDelete($event) {

            close();

            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('This will PERMANENTLY delete this wine record.')
                .ariaLabel('Confirm Deletion')
                .ok('Yes, delete the record!')
                .cancel('No')
                .targetEvent($event);

            $mdDialog.show(confirm).then(function() {
                return userPouch.remove(wine, function(err, response){
                    if (err) {
                        $log.debug('err deleting', response);
                    } else {
                        MessageService.showToast('Record deleted!');

                        $timeout(function(){
                            MessageService.hideToast();
                        }, 3000);
                    }
                });
            }, function() {
                // decided not to, do nothing
            });
        }
    }

})();
